import { Link } from "react-router-dom";

function CrosswordVariant() {
    return (
        <section className="content-wrapper">
            <h1>변형 십자말풀이</h1>
            <hr></hr>
            
        </section>
    )
}

export default CrosswordVariant;